module.exports = __webpack_public_path__ + "static/media/msgIn.e12bf4c7.mp3";